import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Box } from 'foundations-components/transitional/components/Box';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { TieredPricePageSizeSelect } from './TieredPricePageSizeSelect';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TieredPriceModalPaginationSection = ({
  currentPage,
  currentTiersCount,
  itemsPerPage,
  onPageChange,
  numPages,
  setItemsPerPage,
  totalTiersCount
}) => {
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "tiered-price-modal-pagination-section",
    children: [/*#__PURE__*/_jsx(View, {
      as: "div",
      alignSelf: "start",
      paddingBlockEnd: "200",
      "data-test-id": "tiered-price-modal-tiers-count",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.tieredPricing.table.pagination.paginationCount",
        options: {
          currentCount: currentTiersCount,
          count: totalTiersCount
        }
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(Paginator, {
          "data-test-id": "tiered-price-modal-paginator",
          page: currentPage,
          pageCount: numPages,
          onPageChange: onPageChange,
          paddingBlock: "0",
          maxVisiblePageButtons: 3,
          showLastPageNumber: true
        })
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(TieredPricePageSizeSelect, {
          itemsPerPage: itemsPerPage,
          setItemsPerPage: setItemsPerPage
        })
      })]
    })]
  });
};